import React from 'react';
import RegistrationPage from './Registration'; // We'll create this next

function App() {
  return (
    <div className="App">
      <RegistrationPage />
    </div>
  );
}

export default App;